import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { STORE_PROMOTION_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateStorePromotionSettingAction = createAsyncThunk(
    'price/updateStorePromotionSettingAction',
    async (form, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(STORE_PROMOTION_SETTINGS_PATH, form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateStorePromotionSettingSlice = createSlice({
    name: 'updateStorePromotionSettingSlice',
    initialState: DEFAULT_STATE,
    extraReducers: builder => {
        builder.addCase(updateStorePromotionSettingAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateStorePromotionSettingAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateStorePromotionSettingAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateStorePromotionSettingState = (state) => state.price.updateStorePromotionSetting;
export default updateStorePromotionSettingSlice.reducer;